import { useMemo } from 'react';

import { PowerCreator } from '~/models/PowerCreator';
import { formatHMS, getSeconds } from '~/utils';

import { Container, Wrapper } from './styles';

type Props = {
  data: PowerCreator;
  selectedMethods: number[];
  selectMethod: (methodId: string) => void;
  removeMethod: (methodId: string) => void;
};

export function Card({
  data,
  selectedMethods,
  selectMethod,
  removeMethod,
}: Props) {
  const isSelected = useMemo(() => {
    return selectedMethods.includes(data.id);
  }, [selectedMethods, data]);

  const restTime = formatHMS(
    getSeconds(data.total_time ?? '0') - getSeconds(data.total_action ?? '0'),
  );

  const handleSelectCard = () => selectMethod(String(data.id));

  const handleRemoveCard = () => removeMethod(String(data.id));

  return (
    <Container isSelected={isSelected}>
      <Wrapper onClick={isSelected ? handleRemoveCard : handleSelectCard}>
        <div>
          <strong>Método:&nbsp;</strong>
          {data.tranning_method ?? 'Não informado'}
        </div>

        <div>
          <strong>Princípio ativo:&nbsp;</strong>
          {data.method_principle ?? 'Não informado'}
        </div>

        <div>
          <strong>Execução:&nbsp;</strong>
          {data.execution ?? 'Não informado'}
        </div>

        <div>
          <strong>Volume Nº de séries:&nbsp;</strong>
          {data.series_number ?? 'Não informado'}
        </div>

        <div>
          <strong>Volume Nº de repetições:&nbsp;</strong>
          {data.volume_total ?? 'Não informado'}
        </div>

        <div>
          <strong>Tempo de ação total:&nbsp;</strong>
          {data.total_action ?? 'Não informado'} minuto(s)
        </div>

        <div>
          <strong>Intervalo de recuperação total (entre séries):&nbsp;</strong>
          <br />
          {restTime ?? 'Não informado'} minuto(s)
        </div>

        <div>
          <strong>Tempo total:&nbsp;</strong>
          {data.total_time ?? 'Não informado'} minuto(s)
        </div>
      </Wrapper>
    </Container>
  );
}
